import React, { Component } from "react";
import SideBar from "../common/sideBar";
import UserProfile from "../common/userProfile";
import { connect } from "react-redux";
import HelmetComponent from "../common/helmetComponent";
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";

import AddShop from "./addShop";
import { deleted, failed } from "../common/misc";
import ShopGrid from "./shopGrid";
import SortingIcon from "../common/sortingIcon";
import Pagination from "../common/Pagination";
import SortingIconUp from "../common/sortingIconUp";
import { deleteProduct, getShop, loadAllProduct } from "../../store/shop";
import { debounce } from "lodash";
import Search from "./search";

class ShopTable extends Component {
  state = {
    userShow: false,
    modal: false,
    active: false,
    admin_id: "",
    status: "",
    msg: "",
    delete_id: "",
    asside: false,
    isShow: false,
    asside2: false,
    asside3: false,
    sort: "createdAt",
    order: "desc",
    totalRecords: "",
    totalPages: "",
    pageLimit: "",
    currentPage: "",
    editing: false,
    editData: null,
    keyword: "",
  };

  handleSearch = debounce(() => {
    this.props.loadAllProduct({
      page: "1",
      sort: this.state.sort,
      order: this.state.order,
      keyword: this.state.keyword,
    });
  }, 300);

  onSearch = (value) => {
    this.setState(
      {
        keyword: value,
      },
      () => this.handleSearch()
    );
  };

  reset = () => {
    this.setState(
      {
        keyword: "",
      },
      () => this.handleSearch()
    );
  };
  toggleAddShop = () => {
    this.setState({
      isShow: !this.state.isShow,
    });
  };

  toggleEditShop = (event, editData) => {
    if (event) event.preventDefault();
    this.setState({
      isShow: !this.state.isShow,
      editing: true,
      editData,
    });
  };

  toggleShowUser = () => {
    this.setState({
      userShow: !this.state.userShow,
    });
  };

  toggle = (id) => {
    this.setState({
      modal: !this.state.modal,
      delete_id: id,
    });
  };

  deletedProduct = () => {
    this.props.deleteProduct(this.state.delete_id, this.callback);
  };
  callback = (res) => {
    if (res && res.status === 200) {
      this.props.loadAllProduct({
        sort: this.state.sort,
        order: this.state.order,
        page: this.state.currentPage,
      });
      this.setState({
        modal: !this.state.modal,
      });
      // toast(<AlertSuccess message={deleted} />);
    } else {
      toast(<AlertError message={res.data.message} />);
    }
  };
  componentDidMount = () => {
    if (this.state.currentPage) {
      this.props.loadAllProduct({
        page: this.state.currentPage,
        sort: this.state.sort,
        order: this.state.order,
      });
    }
  };

  sortByTitle = () => {
    if (this.state.order === "desc")
      this.setState({
        sort: "name",
        order: "asc",
      });
    else {
      this.setState({
        sort: "name",
        order: "desc",
      });
    }
  };
  sortByCreatedOn = () => {
    if (this.state.order === "desc")
      this.setState({
        sort: "createdAt",
        order: "asc",
      });
    else {
      this.setState({
        sort: "createdAt",
        order: "desc",
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.state.sort !== prevState.sort ||
      this.state.order !== prevState.order
    ) {
      this.props.loadAllProduct({
        page: this.state.currentPage,
        sort: this.state.sort,
        order: this.state.order,
      });
    }
  };

  onChangePage = (data) => {
    this.setState({
      pageLimit: data.pageLimit,
      totalPages: data.totalPages,
      currentPage: data.page,
    });
    if (data.page !== this.state.currentPage) {
      this.props.loadAllProduct({
        page: data.page,
        sort: this.state.sort,
        order: this.state.order,
      });
    }
  };

  render() {
    const products = this.props.products;
    const { total_record, current_page, record_per_page, total_page } =
      this.props.pagination;
    return (
      <div
        className={
          this.state.asside === true ||
          this.state.asside2 === true ||
          this.state.asside3 === true
            ? "header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled"
            : "header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled  aside-minimize"
        }
      >
        <div className="d-flex flex-column flex-root">
          <HelmetComponent title="Trainings Management" />
          <div className="d-flex flex-row flex-column-fluid page">
            <SideBar
              toggleAsside={this.toggleAsside}
              toggleAsside3={this.toggleAsside3}
              userShow={this.state.userShow}
              toggleShowUser={this.toggleShowUser}
              asside={this.state.asside}
              asside3={this.state.asside3}
              asside2={this.state.asside2}
              toggleAsside2={this.toggleAsside2}
            />
            <div
              className="d-flex flex-column flex-row-fluid wrapper"
              id="kt_wrapper"
            >
              <div className="content d-flex flex-column flex-column-fluid">
                <div className="subheader py-2 py-lg-4 subheader-transparent">
                  <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div className="d-flex align-items-center flex-wrap mr-2">
                      <h5 className="text-dark font-weight-bold mt-2 mb-2 mr-5">
                        Products
                      </h5>
                      <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200"></div>
                      <div className="d-flex align-items-center">
                        <span className="text-dark-50 font-weight-bold">
                          Total : {total_record} records
                        </span>
                        <Search
                          keyword={this.state.keyword}
                          onSearch={this.onSearch}
                          reset={this.reset}
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <a
                        href="javascript:void (0)"
                        className="btn btn-primary font-weight-bold btn-sm font-size-base ml-2"
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleAddShop();
                        }}
                        data-toggle="tooltip"
                        data-placement="right"
                        data-container="body"
                        data-boundary="window"
                      >
                        Add Product
                      </a>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column-fluid">
                  <div className="container-fluid">
                    <div className="card card-custom">
                      <div className="card-body">
                        <div className="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded">
                          <table
                            className="datatable-table"
                            style={{ display: "block" }}
                          >
                            <thead className="datatable-head">
                              <tr
                                className="datatable-row"
                                style={{ left: "0px" }}
                              >
                                <th
                                  className="datatable-cell datatable-cell-sort"
                                  style={{ width: "30%" }}
                                >
                                  <span>
                                    Name
                                    {this.state.sort === "name" &&
                                    this.state.order === "asc" ? (
                                      <SortingIcon sorting={this.sortByTitle} />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortByTitle}
                                      />
                                    )}
                                  </span>
                                </th>
                                <th
                                  className="datatable-cell datatable-cell-sort"
                                  style={{ width: "20%" }}
                                >
                                  <span>Stars</span>
                                </th>
                                <th
                                  className="datatable-cell datatable-cell-sort"
                                  style={{ width: "20%" }}
                                >
                                  <span>created By</span>
                                </th>
                                <th
                                  className="datatable-cell datatable-cell-sort"
                                  style={{ width: "15%" }}
                                >
                                  <span>
                                    Created On
                                    {this.state.sort === "createdAt" &&
                                    this.state.order === "asc" ? (
                                      <SortingIcon
                                        sorting={this.sortByCreatedOn}
                                      />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortByCreatedOn}
                                      />
                                    )}
                                  </span>
                                </th>

                                <th
                                  className="datatable-cell datatable-cell-sort"
                                  style={{ width: "20%" }}
                                >
                                  <span>Action</span>
                                </th>
                              </tr>
                            </thead>
                            <ShopGrid
                              delete_id={this.state.delete_id}
                              modal={this.state.modal}
                              toggle={this.toggle}
                              products={products}
                              deleted={this.deletedProduct}
                              toggleEditShop={this.toggleEditShop}
                              history={this.props.history}
                            />
                          </table>
                          <Pagination
                            totalRecords={total_record}
                            total_page={total_page}
                            pageLimit={record_per_page}
                            initialPage={current_page}
                            pagesToShow={5}
                            onChangePage={this.onChangePage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <UserProfile
            userShow={this.state.userShow}
            toggleShowUser={this.toggleShowUser}
          />
          <AddShop
            isShow={this.state.isShow}
            toggleAddShop={this.toggleAddShop}
            initialPage={this.state.currentPage}
            editing={this.state.editing}
            editData={this.state.editData}
            setEdting={(editing) => this.setState({ editing })}
            setEditData={(editData) => this.setState({ editData })}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  products: getShop(state).products,
  pagination: getShop(state).pagination,
});
const mapDispatchToProps = (dispatch) => ({
  loadAllProduct: (param) => dispatch(loadAllProduct(param)),
  deleteProduct: (id, callback) => dispatch(deleteProduct(id, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopTable);
